'use client';

import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';

import { saveUserStorageItems } from '@/api/userStorage';
import { adaptMutation } from '@/modules/common/helpers/swr';
import { userStorageKeys } from '../keys';

export const useSaveUserStorageItems = () => {
  const { mutate } = useSWRConfig();

  return useSWRMutation(
    'saveUserStorageItems',
    adaptMutation(saveUserStorageItems),
    { onSuccess: () => mutate(userStorageKeys.all) }
  );
};
